// extracted by mini-css-extract-plugin
export default {"components":"ReleaseNotesComponents_components_XYRzB","name":"ReleaseNotesComponents_name_qYzBH"};